import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/macro';
import scaleSize from '../../utils/scale-size';
import { Focusable } from '../navigation';
import config from '../../config';

const TITLE_MAX_LENGTH = 35;

const StyledPackageItem = styled(Focusable)`
  width: ${scaleSize(355)}px;
  height: ${scaleSize(512)}px;
  display: inline-block;
  text-align: center;
  margin-right: ${scaleSize(20)}px;
  box-sizing: border-box;
  border-radius: ${scaleSize(12)}px;
  background-color: ${({ theme }) => theme.imagePlaceholder};
  transform: translate3d(0, 0, 0);
  transition: ${config.withAnimation ? 'transform 0.2s' : 'none'};

  cursor: pointer;
  white-space: normal;
  vertical-align: top;

  &:hover {
    transform: translate3d(0, -${scaleSize(10)}px, 0);
  }

  &:focus {
    background-color: ${({ theme }) => theme.activeColor};
    transform: translate3d(0, -${scaleSize(20)}px, 0);

    & > i {
      color: ${({ theme }) => theme.defaultColor};
      border-color: ${({ theme }) => theme.defaultColor};
    }
  }
`;

const PackageItemTitle = styled.div`
  display: inline-block;
  font-size: ${scaleSize(40)}px;
  line-height: 1.2;
  letter-spacing: ${scaleSize(-0.28)}px;
  height: ${scaleSize(34)}px;
  margin: ${scaleSize(100)}px auto 0;
  color: ${({ theme }) => theme.defaultColor};
  font-family: RobotoCondensedBold, sans-serif;
  text-align: center;
  max-width: ${scaleSize(340)}px;
`;

const PackageItemStatus = styled.i`
  display: inline-block;
  font-size: ${scaleSize(34)}px;
  position: absolute;
  width: 100%;
  bottom: ${scaleSize(250)}px;
  left: 0;
  font-stretch: normal;
  font-style: normal;
  font-weight: 500;
  line-height: 1.4;
  letter-spacing: ${scaleSize(-0.24)}px;
  margin-top: ${scaleSize(16)}px;
  color: ${({ theme }) => theme.activeColor};
  font-family: 'RobotoRegular', sans-serif;
  text-align: center;
`;

const PackageItemPrice = styled.div`
  font-size: ${scaleSize(34)}px;
  display: inline-block;
  width: 100%;
  position: absolute;
  bottom: ${scaleSize(124)}px;
  left: 0;
  font-weight: 500;
  line-height: 1.4;
  letter-spacing: normal;
  color: ${({ theme }) => theme.defaultColor};
  font-family: 'RobotoRegular', sans-serif;
  text-align: center;
`;

const PackageItemPeriod = styled.i`
  font-size: ${scaleSize(24)}px;
  display: inline-block;
  width: 100%;
  position: absolute;
  bottom: ${scaleSize(80)}px;
  left: 0;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.17;
  letter-spacing: ${scaleSize(-0.17)}px;
  color: ${({ theme }) => theme.secondaryTextColor};
  font-family: 'RobotoRegular', sans-serif;
  text-align: center;
`;

class PackageItem extends PureComponent {
  onFocus = () => {
    const { onFocus, index } = this.props;

    onFocus && onFocus(index);
  };

  onEnter = () => {
    const { onEnter, index } = this.props;

    onEnter && onEnter(index);
  };

  render() {
    const { item, focusOnMouseEnter } = this.props;

    const { cost, unit, name, status } = item;

    const packagePrice = unit.split('/')[0];
    const packagePeriod = unit.split('/').pop();
    const packageTitle = name.length > TITLE_MAX_LENGTH ? name.slice(0, TITLE_MAX_LENGTH - 3) + '...' : name;

    return (
      <StyledPackageItem
        id={item.domId}
        onFocus={this.onFocus}
        onEnter={this.onEnter}
        focusOnMouseEnter={focusOnMouseEnter}
      >
        <PackageItemTitle>{packageTitle}</PackageItemTitle>
        {status && <PackageItemStatus>{status}</PackageItemStatus>}
        <PackageItemPrice name={packagePrice}>{`${cost} ${packagePrice}`}</PackageItemPrice>
        <PackageItemPeriod>{packagePeriod}</PackageItemPeriod>
      </StyledPackageItem>
    );
  }
}

PackageItem.propTypes = {
  onFocus: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
  focusOnMouseEnter: PropTypes.bool,
};

export default PackageItem;
